export const addSpaceNumberString = (num: number) => {
    return num
        .toString()
        .replace(/^-?\d+/, (num) => num.replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
};
